import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import optOutImage from '@app/assets/sms-opt-out.svg';
import { FC } from 'react';
import { useConfirmOptOutDialogController } from '@app/pages/Profile/ConfirmOptOut/useConfirmOptOutDialogController';

interface ConfirmOptOutProps {
  confirmOpen: boolean;
  closeOptInDialog: () => void;
}
export const ConfirmOptOutDialog: FC<ConfirmOptOutProps> = (props) => {
  const { optOutSMS } = useConfirmOptOutDialogController(props.closeOptInDialog);
  return (
    <>
      <Dialog open={props.confirmOpen} fullWidth>
        <DialogContent>
          <Box
            sx={{
              p: 2,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <img src={optOutImage} alt="Opt Out" />
            <Typography variant={'h2'}>Opt Out of SMS?</Typography>
            <Typography
              variant={'body1'}
              color={'textSecondary'}
              sx={{
                fontWeight: 400,
                textAlign: 'center',
              }}
            >
              By opting out, you&apos;ll miss out on motivation, gentle reminders, and the occasional meme that knows
              exactly how you feel.
            </Typography>
            <Button fullWidth variant={'contained'} onClick={props.closeOptInDialog}>
              Cancel, Don&apos;t Opt Out
            </Button>
            <Button fullWidth variant={'outlined'} onClick={optOutSMS}>
              Yes, Opt Out of SMS
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
